export { default as GDMIcon } from './GDMIcon';

export type { GDMIconComponent, GDMIconProps } from './GDMIcon.type';
